import { ISetTieuChuanRequest } from "../../model/request/set-tieu-chuan/ISetTieuChuanEditRequest"
import { ISetTieuChuanImportRequest } from "../../model/request/set-tieu-chuan/ISetTieuChuanImportRequest"
import { ISetTieuChuan } from "../../model/respone/set-tieu-chuan/ISetTieuChuan"
import { apiClient } from "../apiClient"

export const SET_TIEU_CHUAN_RESOURCE = "set-tc"
export const setTieuChuanApi = {
    SelectAll: () => apiClient.get(`${SET_TIEU_CHUAN_RESOURCE}`),
    Insert: (payload: ISetTieuChuan) => apiClient.post(`${SET_TIEU_CHUAN_RESOURCE}`,payload),
    Update: (payload: ISetTieuChuan) => apiClient.put(`${SET_TIEU_CHUAN_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${SET_TIEU_CHUAN_RESOURCE}/${id}`),
    SelectByCoSo: (id: number) => apiClient.get(`${SET_TIEU_CHUAN_RESOURCE}/co-so/${id}`),
    SaveChange: (payload: ISetTieuChuanRequest) => apiClient.post(`${SET_TIEU_CHUAN_RESOURCE}`, payload),
    LoadFromExcel: (formData: FormData) => apiClient.upload(`${SET_TIEU_CHUAN_RESOURCE}/load-from-excel`, formData),
    Import: (payload: ISetTieuChuanImportRequest) => apiClient.post(`${SET_TIEU_CHUAN_RESOURCE}/import`, payload),

}